import React from 'react';
import { UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { Button } from '../components/Button';
export function ProfileLoggedOutScreen() {
  const navigate = useNavigate();
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-650">
      <Header title="My Profile" showLogo={true} data-id="element-651" />

      <div className="flex-1 flex items-center justify-center px-6" data-id="element-652">
        <div className="text-center max-w-md" data-id="element-653">
          <div className="w-24 h-24 mx-auto mb-6 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-654">
            <UserIcon className="w-12 h-12 text-gray-400" data-id="element-655" />
          </div>

          <h2 className="text-2xl font-bold text-[#1f5070] mb-3" data-id="element-656">
            Sign in to view your profile
          </h2>
          <p className="text-[#666666] mb-8" data-id="element-657">
            Access your bookings, credits, and account settings
          </p>

          <div className="space-y-3" data-id="element-658">
            <Button variant="primary" fullWidth onClick={() => navigate('/login')} data-id="element-659">
              Sign In
            </Button>

            <Button variant="secondary" fullWidth onClick={() => alert('Create account')} data-id="element-660">
              Create Account
            </Button>
          </div>
        </div>
      </div>

      <BottomNav data-id="element-661" />
    </div>;
}